/**
 * DATE UTILITIES
 *
 * Centralized date utility functions for Firestore date range queries
 * across Intel domain services.
 *
 * Date Range Constants Guide:
 * - THREE_MONTHS (3): Use for "current state" views where only recent data matters
 *   (e.g., active workflows, current team allocations)
 * - TWELVE_MONTHS (12): Use for standard rolling year trends and performance metrics
 *   (e.g., project health over time, annual performance tracking)
 */

/** 3-month lookback for current state views (active workflows, current allocations) */
export const THREE_MONTHS = 3;

/** 12-month lookback for standard rolling year trends and performance metrics */
export const TWELVE_MONTHS = 12;

/**
 * Returns a date string in YYYY-MM-DD format for N months ago from current date.
 * Used for Firestore date range queries across Intel domain services.
 *
 * @param months - Number of months to look back
 * @returns Date string in YYYY-MM-DD format (e.g., "2025-01-23")
 */
export function getMonthsAgoString(months: number): string {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date.toISOString().split('T')[0];
}
